<template>
    <div class="n-bg-1 n-p-2">
        <a-row :gutter="[10, 10]"
               class="n-h-1">
            <a-col :span="24"
                   :md="12"
                   :xl="6"
                   :key="item.status"
                   v-for="item in task.datas">
                <a-card :title="getStatus(item.status).title"
                        :loading="item.loading"
                        class="n-bg-2 n-col-1 n-h-1 n-bg-1 n-body-shadow">

                    <div class="n-scroll-v c-task-list">
                        <ul class="n-ul n-m-0 n-p-0"
                            :status="item.status">
                            <li class="c-task-tag n-bg-1 n-plr-2 n-pt-2 n-pb-1 n-radius-3 c-task-list-item n-pointer n-mb-3"
                                v-for="(sItem) in item.list"
                                ref="dragItem"
                                :key="sItem.taskId"
                                :id="sItem.taskId"
                                v-tap="{tap: viewTask, param: sItem}">
                                <a-row align="middle"
                                       justify="space-between">
                                    <a-col flex="1">
                                        <a-row align="middle"
                                               :wrap="false"
                                               :gutter="5">
                                            <a-col><i class="c-priority-bg c-priority-bg-circle"
                                                   :class="'c-priority-bg-' + sItem.priority||'low'"></i></a-col>
                                            <a-col class="n-e-1 n-break-word">{{sItem.taskName}}</a-col>
                                        </a-row>
                                    </a-col>
                                    <!-- <a-col flex="0 0 60px"
                                           class="n-text-right"><span class="c-status-bg c-status-bg-pending n-c-1 n-radius-3 n-plr-1">{{getStatus}}</span></a-col> -->
                                </a-row>
                                <a-row align="middle"
                                       gutter="5"
                                       class="n-mt-3">
                                    <a-col><i class="n-icon n-icon-project c-status c-status-pending n-icon-size-20"></i></a-col>
                                    <a-col>{{sItem.projectName}}</a-col>
                                </a-row>
                            </li>
                            <li class="c-task-list-empty">
                                <a-empty class="c-task-list-empty"
                                         description='暂无可查看任务' />
                            </li>
                        </ul>

                    </div>

                </a-card>

            </a-col>
        </a-row>
    </div>

    <AddTaskBox :visible="showAddTask"
                :projectValue="projectValue"
                :projectOptions="projectOptions"
                :parentTaskCache="parentTaskCache"
                :zIndex="10"
                ref="addTaskBox"
                title="新建任务"
                from="myTask"
                @viewOtherTask="viewOtherTask"
                @close="showAddTask = false"
                @success="projectChange"></AddTaskBox>

    <AddTaskBox :visible="showEditTask"
                :projectValue="projectValue"
                :projectOptions="projectOptions"
                :parentTaskCache="parentTaskCache"
                :zIndex="5"
                ref="editTaskBox"
                title="编辑任务"
                @viewOtherTask="viewOtherTask"
                @close="showEditTask = false"
                @success="projectChange"
                @addSubTask="createTask"></AddTaskBox>
</template>
<script >
    import Sortable from 'sortablejs';
    import { mapMutations, mapState } from 'vuex';
    // import { Draggable } from '@shopify/draggable';
    import nui from '@/assets/script';

    import AddTaskBox from '@/components/AddTaskBox'

    export default {
        name: 'MyTask',
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),

        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                dragObj: [],

                projectValue: null,
                projectOptions: [],

                parentTaskCache: undefined,


                task: {
                    datas: [{
                        status: 1, list: [], loading: true
                    }, {
                        status: 2, list: [], loading: true
                    }, {
                        status: 3, list: [], loading: true
                    }, {
                        status: 4, list: [], loading: true
                    }, {
                        status: 0, list: [], loading: true
                    }]
                },

                showAddTask: false,
                showEditTask: false,
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat(['setWindowSize'])),

            NMounted () {
                this.getTask()
            },
            initDrag () {
                document.querySelectorAll('.c-task-list ul').forEach(item => {
                    this.dragObj.push(Sortable.create(item, {
                        group: 'task',
                        sort: false,
                        animation: 100,
                        onEnd: (res) => {
                            var newStatus = res.to.getAttribute('status'),
                                oldStatus = res.from.getAttribute('status'),
                                id = res.item.getAttribute('id'),
                                cache = this.extend([], this.group), target

                            console.log(123123123);

                            if (newStatus == oldStatus) {
                                return
                            }


                            this.request(this.API.updateTaskStatus, {
                                method: 'post',
                                data: { taskId: id, status: newStatus }
                            }).then(res => {
                                if (res.code != this.REQUEST_SUCCESS_CODE) {
                                    this.error(res.msg)
                                }
                            })
                        }
                    }));
                })

                // this.dragObj && this.dragObj.destroy()
                // this.dragObj = new Draggable(document.querySelectorAll('.c-task-list'), {
                //     draggable: '.c-task-list-item'
                // });

                // var dragItems = this.$refs.dragItem;

                // if (dragItems) {
                //     dragItems.forEach(item => {
                //         item.style.width = item.offsetWidth + 'px'
                //     })
                // }

                // this.dragObj.on('drag:over:container', (res) => {
                //     this.over = res.data;
                // });

                // this.dragObj.on('drag:stop', (res) => {
                //     var newStatus = this.over.overContainer.getAttribute('status'),
                //         oldStatus = res.data.sourceContainer.getAttribute('status'),
                //         id = res.data.source.getAttribute('id');

                //     var cache = this.extend([], this.task.datas), target

                //     cache = cache.map(item => {
                //         if (item.status == oldStatus) {
                //             target = this.extend([], item.list.filter(fItem => fItem.taskId == id));
                //             item.list = item.list.filter(fItem => fItem.taskId != id)
                //         }

                //         return item
                //     })

                //     cache = cache.map(item => {
                //         if (item.status == newStatus) {
                //             item.list = item.list.concat(target)
                //         }

                //         return item
                //     })

                //     this.task.datas = cache;

                //     this.request(this.API.updateTaskStatus, {
                //         method: 'post',
                //         data: { taskId: id, status: newStatus }
                //     }).then(res => {
                //         if (res.code != this.REQUEST_SUCCESS_CODE) {
                //             this.error(res.msg)
                //         }
                //     })

                // });
            },
            /**
             * @description 我的任务
             */
            getTask () {
                this.request(this.API.myTask).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE) {
                        this.task.datas = res.data.map(item => {
                            return {
                                status: item.status,
                                list: item.taskVoList,
                                // list: [{ "taskId": 734, "subCount": 1, "taskName": "任务标题否定你稍等发给你", projectId: 344, projectName: '概览项目TEST101' }],
                                loading: false
                            }
                        });


                        this.$nextTick(this.initDrag)
                    } else {
                        this.error(res.msg);
                    }
                })
            },
            viewOtherTask (taskId) {
                this.showAddTask = false;
                this.showEditTask = false;
                this.parentTaskCache = {};
                setTimeout(() => {
                    this.showEditTask = true;
                    this.$nextTick(() => {
                        this.$refs.editTaskBox.getDetail(taskId, false);
                    })
                }, 50);
            },
            /**
             * @description 创建任务
             */
            createTask (data) {
                this.parentTaskCache = { id: data.key, name: data.title }
                this.showAddTask = true;
            },
            /**
            * @description 编辑任务
            */
            editTask (data) {
                this.projectValue = data.projectId;
                this.projectOptions = [{ value: data.projectId, label: data.projectName }];

                this.showEditTask = true;

                this.$nextTick(() => {
                    this.$refs.editTaskBox.getDetail(data.taskId, true)
                })
            },
            /**
            * @description 查看任务
            */
            viewTask (data) {
                this.projectValue = data.projectId;
                this.projectOptions = [{ value: data.projectId, label: data.projectName }];

                this.showEditTask = true;

                this.$nextTick(() => {
                    this.$refs.editTaskBox.getDetail(data.taskId, false);
                })
            },
            /**
            * @description 切换项目更新数据
            */
            projectChange () {
                this.getTask()

                this.$nextTick(() => {
                    this.$refs.editTaskBox && this.showEditTask && this.$nextTick(() => {
                        this.$refs.editTaskBox.getDetail()
                    })
                })
            }
        }),
        components: {
            AddTaskBox
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .c-task-list {
        height: calc(100vh - 210px);

        ul {
            position: relative;
            min-height: 100%;

            .c-task-list-empty {
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -100%);
            }
        }

        .c-task-list-item {
            position: relative;
            z-index: 5;

            & + .c-task-list-empty {
                display: none;
            }
        }
    }

    @media screen and (max-width: 1200px) {
        .c-task-list {
            height: auto;

            ul {
                min-height: 300px;
            }
        }
    }
</style>